export default [
  {
    name: 'statistics-checkin',
    path: '/statistics-checkin',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'Estatísticas - Check-In',
      icon: 'dvr',
      label: 'Participantes',
      roles: ['Admin']
    }
  }
]
